import * as i0 from '@angular/core';
import { Pipe, inject, SimpleChange, Input, Inject, Directive } from '@angular/core';
import * as i1 from '@scalefast/config-angular';
import * as i1$1 from '@angular/router';
import { RouterLink } from '@angular/router';
import { PRODUCT_SLUGGER_SERVICE } from '@scalefast/ecommerce-core';
let StaticFileHash = /*#__PURE__*/(() => {
  class StaticFileHash {
    constructor(storeSpecificService) {
      this.storeSpecificService = storeSpecificService;
    }
    transform(filePath) {
      return filePath + '?buildId=' + this.storeSpecificService.get().buildId;
    }
    static {
      this.ɵfac = function StaticFileHash_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || StaticFileHash)(i0.ɵɵdirectiveInject(i1.StoreSpecificConfigService, 16));
      };
    }
    static {
      this.ɵpipe = /* @__PURE__ */i0.ɵɵdefinePipe({
        name: "staticFileHash",
        type: StaticFileHash,
        pure: true,
        standalone: true
      });
    }
  }
  return StaticFileHash;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Directive to generate canonical product links using a product and a slug
 * It uses RouterLink under the hood
 * TODO It doesn't support updates as it's not needed for the current use case, may be needed soon
 * TODO slugger is hardcoded from helpers, we should support injecting it
 *
 * Not sure where this type of directive should live, if we put it in angular-core it creates
 * a circular dependency. We may need a new package for this type of use case or think more where they belong
 */
let SfProductLinkDirective = /*#__PURE__*/(() => {
  class SfProductLinkDirective {
    constructor(routerLinkDirective = inject(RouterLink), slugger) {
      this.routerLinkDirective = routerLinkDirective;
      this.slugger = slugger;
      this.link = null;
    }
    updateLink() {
      let link;
      if (!this.sfProductLink) {
        link = null;
      } else {
        link = this.slugger.getRouterLink(this.sfProductLink);
      }
      this.link = link;
    }
    ngOnInit() {
      this.updateLink();
      this.routerLinkDirective.routerLink = this.link;
      // This is needed for the product to update, solution found in https://github.com/angular/angular/issues/51046
      this.routerLinkDirective.ngOnChanges({
        routerLink: new SimpleChange(null, this.link, true)
      });
    }
    static {
      this.ɵfac = function SfProductLinkDirective_Factory(__ngFactoryType__) {
        return new (__ngFactoryType__ || SfProductLinkDirective)(i0.ɵɵdirectiveInject(i1$1.RouterLink), i0.ɵɵdirectiveInject(PRODUCT_SLUGGER_SERVICE));
      };
    }
    static {
      this.ɵdir = /* @__PURE__ */i0.ɵɵdefineDirective({
        type: SfProductLinkDirective,
        selectors: [["", "sfProductLink", ""]],
        inputs: {
          sfProductLink: "sfProductLink"
        },
        standalone: true,
        features: [i0.ɵɵHostDirectivesFeature([i1$1.RouterLink])]
      });
    }
  }
  return SfProductLinkDirective;
})();
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { SfProductLinkDirective, StaticFileHash };
